<template lang="pug">
div.fill-nav
    div.title {{cont.stem}}
    .hint {{cont.hint}}
            div.tag
              ul
                  Tag(v-for='i in item.type',
                      :key='i',closable,
                      @on-close="handleClose(i)",
                      :closable='!cont.isShow') {{i}}
                  button(type='button',
                      v-if='addTag&&!cont.isShow',
                      @click='fun_addButton').text-button 点击添加
                  Input(v-show='!addTag&&!cont.isShow',@on-blur='fun_addTag',
                      ref='addInput'
                      v-model.trim='addTagData'
                      placeholder="最大50字"
                      :maxlength="50"
                      ).add-tag
</template>
<script>
export default {
  props: ["cont", "HistoryData"],
  data() {
    return {
      value: "",
      addTag: true,
      addTagData: "",
      item: {
        type: []
      },
      id: false
    };
  },
  created() {
    if (this.cont.isShow) {
      JSON.parse(this.cont.metas).forEach(res => {
        this.item.type.push(res);
      });
    }
    if (this.HistoryData) {
      this.item.type = JSON.parse(this.HistoryData.questionAnswer);
      this.id = this.HistoryData.id;
    }
  },
  methods: {
    handleClose(name) {
      const index = this.item.type.indexOf(name);
      this.item.type.splice(index, 1);
    },
    fun_addButton() {
      this.addTag = !this.addTag;
      this.$nextTick(() => {
        console.log(this.$refs);
        this.$refs.addInput.focus();
      });
    },
    fun_addTag() {
      const that = this;
      function find(value) {
        console.log(value);
        console.log(that.addTagData);
        return value === that.addTagData;
      }
      console.log(this.item.type.find(find));
      if (!this.item.type.find(find) && this.addTagData) {
        // if (this.addTagData) {
        this.item.type.push(this.addTagData);
        this.addTagData = "";
        this.addTag = !this.addTag;
      }
    },
    listenKeyword() {
      // 限制50个字的方法
      if (this.addTagData.length > 50) {
        this.$Message.error("已经超出50字啦!将会只录入前50个字哦!");
        this.addTagData = this.addTagData.slice(0, 50);
      }
    }
  }
};
</script>
<style lang="stylus" socped>
.fill-nav
  background #fff

  .title
    font-size 16px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 1)
  .hint
    margin-bottom 8px
    color #7b7272
    .tag
      padding 7px
      width 100%
      height 74px
      background rgba(255, 255, 255, 1)
      border-radius 4px
      border 1px solid rgba(210, 221, 236, 1)
      font-size 14px
      font-family MicrosoftYaHeiUI
      color rgba(42, 46, 54, 0.75)
      text-align left
      overflow auto
      .tag-b
        min-width 72px
        height 28px
        line-height 28px
        background rgba(56, 133, 225, 1)
        border-radius 4px
        border none
        color #fff
        outline none
        float left
        margin-right 8px
        margin-top 2px
        cursor pointer
    .add-tag
      width 120px
      border none
      outline none
    .ivu-input
      width 160px
      height 25px
      border none
      outline none
    .ivu-input:focus
      border none
      outline none
      box-shadow none
    .ivu-tag
      background rgba(56, 133, 225, 1)
      border-radius 4px
      border none
      height 28px
      line-height 28px
      .ivu-tag-text
        color #ffffff
      .ivu-icon-ios-close
        color #ffffff
</style>
